import { render, staticRenderFns } from "./BedCheckinTab.vue?vue&type=template&id=ef835d74&scoped=true&"
import script from "./BedCheckinTab.vue?vue&type=script&lang=js&"
export * from "./BedCheckinTab.vue?vue&type=script&lang=js&"
import style0 from "./BedCheckinTab.vue?vue&type=style&index=0&id=ef835d74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef835d74",
  null
  
)

export default component.exports